<ng-progress
  class="kr-mass-pay-out__progress-bar"
  #progressBar
  min="5"
  max="100"
  data-testid="mass_pay_out_progress_bar" />
@if (isEstimateExecuting()) {
  <fu-spinner data-testid="mass_pay_out_estimate_spinner"></fu-spinner>
  <div
    class="kr-mass-pay-out__progress-percentage"
    data-testid="mass_pay_out_progress_percentage">
    {{ progressBar?.progressRef?.progress() || 0 }}%
  </div>
}

<div class="kr-mass-pay-out__header" data-testid="mass_pay_out_header">
  <h4
    class="kr-mass-pay-out__header-text"
    data-testid="mass_pay_out_header_text">
    {{ header }}
  </h4>

  <button
    class="kr-mass-pay-out__header-btn-close"
    type="button"
    fuButton
    uiType="quaternary"
    size="m"
    [onlyIcon]="true"
    data-testid="mass_pay_out_btn_close"
    (click)="close()">
    <fu-icon
      iconName="close-square"
      data-testid="mass_pay_out_icon_close"></fu-icon>
  </button>
</div>

<form
  class="kr-mass-pay-out__body"
  [formGroup]="form"
  (ngSubmit)="next()"
  data-testid="mass_pay_out_form">
  <div class="kr-mass-pay-out__content" data-testid="mass_pay_out_content">
    <kr-wallet-card
      [wallet]="wallet"
      large
      data-testid="mass_pay_out_wallet_card" />

    <fu-icon
      class="kr-mass-pay-out__content-icon-arrow"
      iconName="arrow-right-filled"
      size="48"
      data-testid="mass_pay_out_icon_arrow_right">
    </fu-icon>

    <div
      class="kr-mass-pay-out__content-uploader"
      data-testid="mass_pay_out_content_uploader">
      <fu-uploader
        #uploader
        formControlName="file"
        [apiHost]="apiHost"
        [api]="'/transactions/payout/mass/chunks/process-file/'"
        [headers]="getHeaders()"
        accept=".csv"
        hasData
        placeholderKey="massPayOut.placeholder.upload"
        subPlaceholderKey="massPayOut.placeholder.dnd"
        hiddenBrowse
        hiddenPlaceholder
        data-testid="mass_pay_out_uploader"
        (loadingError)="openFailedDialog($event, false)">
        <ng-template #filesTpl data-testid="mass_pay_out_files_template">
          @if (uploader.files.length) {
            <div
              class="fu-uploader-info"
              (click)="uploader.removeFile($event, 0)"
              data-testid="mass_pay_out_uploader_info">
              <fu-icon
                class="kr-mass-pay-out__uploader-icon-success"
                iconName="success"
                size="32"
                data-testid="mass_pay_out_uploader_icon_success">
              </fu-icon>

              <fu-icon
                class="kr-mass-pay-out__uploader-icon-remove"
                iconName="trash-circle"
                size="32"
                data-testid="mass_pay_out_uploader_icon_remove">
              </fu-icon>

              <span
                class="fu-uploader-info__message"
                data-testid="mass_pay_out_uploader_file_name">
                {{ uploader.files[0].name }}
              </span>

              <span
                class="fu-uploader-info__sub-message"
                translate="massPayOut.placeholder.uploaded"
                data-testid="mass_pay_out_uploader_sub_message">
              </span>
            </div>
          }
        </ng-template>
      </fu-uploader>
    </div>
  </div>

  <div class="kr-actions" data-testid="mass_pay_out_actions">
    <button
      type="button"
      fuButton
      size="m"
      uiType="primary"
      (click)="close()"
      translate="massPayOut.btn.back"
      data-testid="mass_pay_out_btn_back"></button>

    <button
      type="submit"
      fuButton
      size="m"
      uiType="primary"
      [disabled]="
        !form.valid || !form.controls.file.value || isEstimateExecuting()
      "
      translate="massPayOut.btn.next"
      data-testid="mass_pay_out_btn_next"></button>
  </div>
</form>

<ng-template #failedTpl data-testid="mass_pay_out_failed_template">
  <fu-icon iconName="failed" size="64" data-testid="mass_pay_out_icon_failed">
  </fu-icon>

  <h5
    class="kr-transfer-details__message"
    translate="transferDetails.failed.message"
    data-testid="mass_pay_out_failed_message"></h5>

  <div
    class="kr-details kr-details_center"
    data-testid="mass_pay_out_failed_details">
    <label
      class="kr-details__label"
      translate="transferDetails.failed.label.error"
      data-testid="mass_pay_out_failed_error_label">
    </label>

    <span
      class="kr-details__value kr-details_danger"
      data-testid="mass_pay_out_failed_error_value">
      {{ errMessage | translate }}
    </span>
  </div>
</ng-template>
